import * as React from "react";
import type { SVGProps } from "react";
const SvgBank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 15v-2.669M9.333 15v-2.669M14.667 15v-2.669M20 15v-2.669M2.4 18.4h19.2v3.2H2.4zm0-9.6V6.667L11.606 2.4 21.6 6.667V8.8z"
    />
  </svg>
);
export default SvgBank;
